/* FizzyIQ — registered-trademark sizing (fzy-reg).
   Walks text nodes site-wide and wraps every ® in <span class="fzy-reg"> so CSS
   can render it at half size. Catches ® from any source — section markup,
   editor settings, JSON template content — in one pass. Skips form fields,
   script/style, and anything already wrapped (.fzy-reg / the PDP hero .tm-reg). */
(function () {
  'use strict';

  var REG = '®';
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1, PRE: 1, OPTION: 1 };

  function process(root) {
    if (!root || !root.ownerDocument && root.nodeType !== 1 && root.nodeType !== 9) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf(REG) === -1) return NodeFilter.FILTER_REJECT;
        var p = node.parentNode;
        if (!p || p.nodeType !== 1) return NodeFilter.FILTER_REJECT;
        if (SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('.fzy-reg, .tm-reg')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var parts = node.nodeValue.split(REG);
      var frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        if (parts[j]) frag.appendChild(document.createTextNode(parts[j]));
        if (j < parts.length - 1) {
          var span = document.createElement('span');
          span.className = 'fzy-reg';
          span.textContent = REG;
          frag.appendChild(span);
        }
      }
      if (node.parentNode) node.parentNode.replaceChild(frag, node);
    }
  }

  function run() { process(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Re-process sections that reload in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) process(e.target);
  });
})();
